/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RecruitmentInputs */

const cs_enum_recruitment = /** @type {(inputs: Enum_RecruitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nábor`)
};

const en_enum_recruitment = /** @type {(inputs: Enum_RecruitmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recruitment`)
};

/**
* | output |
* | --- |
* | "Recruitment" |
*
* @param {Enum_RecruitmentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_recruitment = /** @type {((inputs?: Enum_RecruitmentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RecruitmentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_recruitment(inputs)
	return cs_enum_recruitment(inputs)
});